import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

const Image = ({ src, cover = false, ...rest }) => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: allFile(
        filter: { sourceInstanceName: { eq: "images" } }
      ) {
        edges {
          node {
            publicURL
            relativePath
            childImageSharp {
              fluid(maxWidth: 2000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `);

  const image = data.placeholderImage.edges.find(element => {
    return element.node.relativePath === src;
  });

  if (!image) {
    return null;
  }

  if (image.node.childImageSharp) {
    return (
      <Img
        {...rest}
        fluid={image.node.childImageSharp.fluid}
        imgStyle={{ objectFit: cover ? 'cover' : 'contain' }}
      />
    );
  }

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img {...rest} src={image.node.publicURL} />;
};

export default Image;
